//Utilitario para funciones asociadas a arrays

export function esListaNoVacia(array) {
  return Array.isArray(array) && array.length > 0;
}
